var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['tabs-wrapper']},[_c('AntTabBar',_vm._l((_vm.tabs),function(tab){return _c('AntTabPane',{key:tab.label,attrs:{"tab":tab.label}},[_vm._t(tab.label)],2)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }